import { api } from './client'

const searchService = {
  quickSearch: async (searchTerm) => {
    if (!searchTerm || searchTerm.length < 2) return []
    const resp = await api.get('/search', { q: searchTerm })
    return resp.data
  },

  globalSearch: async (searchTerm) => {
    if (!searchTerm || searchTerm.length < 2) return { results: [] }
    const resp = await api.get('/search', { q: searchTerm })
    return { results: resp.data, total: resp.meta.total }
  },

  // Smart search: rank which reports fit a query. `reports` is the catalog the caller
  // already has ({id, name, summary}); the server (Workers AI) ranks it and returns
  // only real ids. Returns [{ id, name, reason }].
  reportSuggestions: async ({ query, reports }) => {
    if (!query || query.trim().length < 3 || !reports?.length) return []
    // Lives in the reports domain (ai.run 502'd from the search domain).
    const resp = await api.post('/reports/suggestions', { query, reports })
    return resp?.data?.suggestions || []
  },
}

export default searchService
